module.exports = __webpack_public_path__ + "media/brands/wsk-2caa9126.png";